import { IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateInformacaoFaturamnetoColumnsDefinition
 */

type Props = {
    onActionEdit: (idFaturamento: number | null, openState: boolean) => void,
    onActionDelete: (idFaturamento: number | null, openState: boolean) => void,
};

export const GenerateCentroCustoEnderecoColumnsDefinition = ({
    onActionEdit,
    onActionDelete,
}: Props): GridColDef[] => {

    const computeItemStatusColor = (principal: number) => {
        switch (principal) {
            case 1:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-primary-green";
            case 0:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-red-500";
            default:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-blue-500";
        }
    };

    const computeItemStatusDescription = (principal: number) => {
        switch (principal) {
            case 1:
                return "Sim";
            case 0:
                return "Não";
            default:
                return "?";
        }
    };


    return [
        {
            field: "principal",
            filterable: false,
            headerName: "Principal",
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center" >
                    <Tooltip title={computeItemStatusDescription(params.value)}>
                        <div className={computeItemStatusColor(params.value)}>
                            <h1 className="text-white">{computeItemStatusDescription(params.value)}</h1>
                        </div>
                    </Tooltip>
                </div>
            )
        },
        {
            field: "tipoEndereco",
            filterable: false,
            headerName: "Tipo de Endereço",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "cep",
            filterable: false,
            headerName: "Cep",
            flex: 0,
            minWidth: 200,
            maxWidth: 300,
            sortable: false,
        },
        {
            field: "cidade",
            filterable: false,
            headerName: "Cidade",
            minWidth: 200,
            sortable: false,
        },
        {
            field: "rua",
            filterable: false,
            headerName: "Rua",
            minWidth: 200,
            sortable: false,
        },
        {
            field: 'idCentroCustoEndereco',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 100,
            flex: 0,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2" >
                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        < IconButton onClick={() => onActionDelete(params.value, true)
                        }>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }
    ];
}